/* eslint-disable radix */
import jwt_decode from 'jwt-decode';
import {
  getUsuarioLocalStorage,
  getTokenLocalStorage,
} from './localStorage.util';

export function verificaToken() {
  const CryptoJS = require('crypto-js');
  const usuario = getUsuarioLocalStorage();
  const token = getTokenLocalStorage();
  const key = token && token.replace('bearer ', '');
  const decoded = key && jwt_decode(key);

  if (
    key === null ||
    key === undefined ||
    usuario === null ||
    usuario === undefined
  ) {
    return false;
  }

  if (
    usuario.usuarioId !== parseInt(decoded.sub) ||
    usuario.usuario !== decoded.nameid
  ) {
    return false;
  }

  const exp = decoded.exp;
  const agora = new Date().getTime();

  if (exp < agora / 1000) {
    return false;
  }

  const acessos = usuario.role;
  if (acessos === null || acessos === undefined) {
    return false;
  }

  try {
    const transithmac = acessos.substring(0, 64);
    const transitencrypted = acessos.substring(64);
    const decryptedhmac = CryptoJS.HmacSHA256(
      transitencrypted,
      CryptoJS.SHA256(decoded.jti)
    ).toString();
    if (
      transithmac === null ||
      transithmac === undefined ||
      transithmac !== decryptedhmac
    ) {
      return false;
    }
  } catch (error) {
    return false;
  }

  return true;
}



// WEBPACK FOOTER //
// ./src/acessos.token.js